import { Grid, makeStyles, Theme, Box, Link } from "@material-ui/core";
import { colors } from "swyft-react-core";
import { Link as RouterLink } from "react-router-dom";

import { TF } from "./typography/TF";
import { FacebookIcon, LinkedinIcon, TwitterIcon, YoutubeIcon } from "./icon";
import {
  SwyftContactCorkPhoneNumber,
  SwyftContactCorkPhoneNumberLink,
  SwyftContactDublinPhoneNumber,
  SwyftContactDublinPhoneNumberLink,
  SwyftEmail,
  SwyftEmailLink
} from "../app/consts";
import { LogoSwyftWhyte } from "./Icons";
import { fontFamily } from "../app/theme";
import { useBreakpoint } from "../hooks/useBreakpoint";

export const NewFooter = () => {
  const classes = useStyles();
  const { isMoreThanLg, isMoreThanMd, isMoreThanSm } = useBreakpoint();

  return (
    <footer className={classes.footer}>
      <Box px={isMoreThanLg ? "140px" : "30px"} className={classes.root}>
        <Box overflow="hidden">
          <Grid container spacing={isMoreThanLg ? 6 : 1}>
            <Grid item xs={4} sm={6} md={3}>
              <RouterLink to="/">
                <LogoSwyftWhyte className={classes.logo} />
              </RouterLink>
            </Grid>
            {isMoreThanMd && (
              <Grid item xs={12} sm={6} md={3}>
                <Box textAlign="left">
                  <TF
                    upperCase
                    variant="h5"
                    color="#cda3e3"
                    fontSize={isMoreThanSm ? "16px" : "14px"}
                    className={classes.root}
                  >
                    GET IN TOUCH
                  </TF>

                  <Box mt={1}>
                    <Box display="flex" textAlign="left">
                      <Box>
                        <TF gutterBottom fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                          Cork: <Link href={SwyftContactCorkPhoneNumberLink}>{SwyftContactCorkPhoneNumber}</Link>
                        </TF>
                        <TF gutterBottom fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                          Dublin: <Link href={SwyftContactDublinPhoneNumberLink}>{SwyftContactDublinPhoneNumber}</Link>
                        </TF>

                        <TF component="span" fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                          E: <Link href={SwyftEmailLink}>{SwyftEmail}</Link>
                        </TF>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}
            {isMoreThanMd && (
              <Grid item xs={12} sm={6} md={3}>
                <Box textAlign="left">
                  <TF
                    upperCase
                    variant="h5"
                    fontSize={isMoreThanSm ? "16px" : "14px"}
                    color="#cda3e3"
                    className={classes.root}
                  >
                    Headquarter
                  </TF>
                  <Box display="flex" mt={1} textAlign="left">
                    <Box>
                      <TF upperCase fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        Cork
                      </TF>
                      <TF fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        The Rubicon Centre, Bishopstown, Cork <br /> T12 Y275
                      </TF>
                    </Box>
                  </Box>
                  <Box display="flex" mt={3} textAlign="left">
                    <Box>
                      <TF upperCase fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        Dublin
                      </TF>
                      <TF fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        Unit 17 North West Centre, North West Business Park, Dublin 15, D15DH24
                      </TF>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={8} sm={6} md={3}>
              <Box className={classes.social}>
                <Link href="https://www.facebook.com/swyftenergy/" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon />
                </Link>
                <Link href="https://twitter.com/swyftenergyie" target="_blank" rel="noopener noreferrer">
                  <TwitterIcon />
                </Link>
                <Link href="https://www.linkedin.com/company/swyft-energy" target="_blank" rel="noopener noreferrer">
                  <LinkedinIcon />
                </Link>
                <Link
                  href="https://www.youtube.com/channel/UCmqS5nkzn6CMeb-iIYPMHdA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <YoutubeIcon />
                </Link>
              </Box>
              {isMoreThanMd && (
                <Box ml={1} mt="35px">
                  <Box>
                    <img loading="lazy" src={"images/5star.svg"} alt="5star" className="mb-2" />
                  </Box>
                  <Box>
                    <TF variant="h5" fontSize="19px" className={classes.rate}>
                      Rated <span className="font-semibold">4.8/5 stars</span> over{" "}
                      <span className="font-semibold">500+ customer reviews</span>
                    </TF>
                  </Box>
                  <Box className="cursor-pointer" mt={"19px"}>
                    <Link
                      href="https://www.google.com/search?q=swyft+energy+dublin&ei=pTwkZPndLbPA8gKByKewDA&ved=0ahUKEwi5xKDznoH-AhUzoFwKHQHkCcYQ4dUDCA8&uact=5&oq=swyft+energy+dublin&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzILCC4QgAQQxwEQrwEyBggAEAcQHjIICAAQigUQhgMyCAgAEIoFEIYDMggIABCKBRCGAzoKCAAQRxDWBBCwA0oECEEYAFDOCljOCmCqD2gBcAF4AIABNYgBNZIBATGYAQCgAQHIAQjAAQE&sclient=gws-wiz-serp#lrd=0x486712ba8bc294d1:0x4d83f2e0cb44d117,1,,,,"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TF variant="h5" fontSize="20px" color="#cda3e3">
                        Leave us a Google review
                      </TF>
                    </Link>
                  </Box>
                </Box>
              )}
            </Grid>
            {!isMoreThanMd && (
              <Grid item xs={12} sm={6} md={3}>
                <Box textAlign="left" mt="30px">
                  <TF
                    upperCase
                    variant="h5"
                    color="#cda3e3"
                    fontSize={isMoreThanSm ? "16px" : "14px"}
                    className={classes.root}
                  >
                    GET IN TOUCH
                  </TF>

                  <Box mt={1}>
                    <Box display="flex" textAlign="left">
                      <Box>
                        <TF gutterBottom fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                          Cork: <Link href={SwyftContactCorkPhoneNumberLink}>{SwyftContactCorkPhoneNumber}</Link>
                        </TF>
                        <TF gutterBottom fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                          Dublin: <Link href={SwyftContactDublinPhoneNumberLink}>{SwyftContactDublinPhoneNumber}</Link>
                        </TF>

                        <TF component="span" fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                          E: <Link href={SwyftEmailLink}>{SwyftEmail}</Link>
                        </TF>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}
            {!isMoreThanMd && (
              <Grid item xs={12} sm={6} md={3}>
                <Box textAlign="left" mt="30px">
                  <TF
                    upperCase
                    variant="h5"
                    fontSize={isMoreThanSm ? "16px" : "14px"}
                    color="#cda3e3"
                    className={classes.root}
                  >
                    Headquarter
                  </TF>
                  <Box display="flex" mt={1} textAlign="left">
                    <Box>
                      <TF upperCase fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        Cork
                      </TF>
                      <TF fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        The Rubicon Centre, Bishopstown, Cork <br /> T12 Y275
                      </TF>
                    </Box>
                  </Box>
                  <Box display="flex" mt={3} textAlign="left">
                    <Box>
                      <TF upperCase fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        Dublin
                      </TF>
                      <TF fontSize={isMoreThanSm ? "16px" : "14px"} className={classes.root}>
                        Unit 17 North West Centre, North West Business Park, Dublin 15, D15DH24
                      </TF>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
          <Box display={"flex"} mb="45px" mt="45px" alignItems={"center"} justifyContent={"center"}>
            <Box display={"flex"} flexWrap={"wrap"} alignItems={"center"} justifyContent={isMoreThanMd ? "" : "center"}>
              <Box
                mx={isMoreThanMd ? 6 : isMoreThanSm ? 3 : 0}
                mb={isMoreThanSm ? 0 : 1}
                width={isMoreThanSm ? "auto" : "100%"}
                textAlign={isMoreThanSm ? "center" : "left"}
              >
                <TF color="#cda3e3" variant="caption" className={`${classes.opacity} ${classes.root}`}>
                  <Link
                    href="https://www.swyftenergy.ie/terms-and-conditions-general"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms &amp; Conditions (General)
                  </Link>
                </TF>
              </Box>
              <Box
                mx={isMoreThanMd ? 6 : isMoreThanSm ? 3 : 0}
                width={isMoreThanSm ? "auto" : "100%"}
                mb={isMoreThanSm ? 0 : 1}
                textAlign={isMoreThanSm ? "center" : "left"}
              >
                <TF color="#cda3e3" variant="caption" className={`${classes.opacity} ${classes.root}`}>
                  <Link
                    href="https://www.swyftenergy.ie/terms-and-conditions-servicing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms &amp; Conditions (Servicing)
                  </Link>
                </TF>
              </Box>
              <Box
                mx={isMoreThanMd ? 6 : isMoreThanSm ? 3 : 0}
                width={isMoreThanSm ? "auto" : "100%"}
                textAlign={isMoreThanSm ? "center" : "left"}
              >
                <TF color="#cda3e3" variant="caption" className={`${classes.opacity} ${classes.root}`}>
                  <Link href="https://www.swyftenergy.ie/privacy-policy" target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                  </Link>
                </TF>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </footer>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontFamily: fontFamily.Axiforma
  },
  logo: {
    width: "116px",
    [theme.breakpoints.down("md")]: {
      width: "87px",
      textAlign: "left",
      display: "flex",
      justifyContent: "start"
    }
  },
  rate: {
    "color": "#fff",
    "& .font-semibold": {
      fontWeight: 600
    }
  },
  social: {
    "& a": {
      margin: "0 0.5em",
      color: "#cda3e3 !important"
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "right"
    }
  },
  footer: {
    "paddingTop": theme.spacing(6),
    "backgroundColor": "#160037",
    "color": colors.white,
    "textAlign": "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left"
    },
    "& a": {
      color: colors.white
    }
  },
  opacity: {
    "& a": {
      color: "#cda3e3 !important",
      fontSize: "14px"
    }
  },
  button: {
    marginBottom: theme.spacing(4)
  }
}));
